import { render, staticRenderFns } from "./SocialStatuseUpdate.vue?vue&type=template&id=ef5b5366&"
import script from "./SocialStatuseUpdate.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports